import { render } from "./TokenPopup.vue?vue&type=template&id=2d38c023&scoped=true"
import script from "./TokenPopup.vue?vue&type=script&lang=js"
export * from "./TokenPopup.vue?vue&type=script&lang=js"

import "./TokenPopup.vue?vue&type=style&index=0&id=2d38c023&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d38c023"]])

export default __exports__